
import request from '@/utils/request'
//查询审批
export function queryMatter(id) {
    return request({
        url: '/bpm/task/list-by-process-instance-id?processInstanceId=' + id,
        head: 'application/json;charset=UTF-8',
        method: 'get',
    })
}

//审批通过
export function approveMatter(data) {
    return request({
        url: '/bpm/task/approve',
        data,
        head: 'application/json;charset=UTF-8',
        method: 'put',
    })
}
//审批终止
export function rejectMatter(data) {
    return request({
        url: '/bpm/task/reject',
        data,
        head: 'application/json;charset=UTF-8',
        method: 'put',
    })
}

//审批驳回
export function rollbackMatter(data) {
    return request({
        url:'/bpm/task/rollback',
        data,
        head: 'application/json;charset=UTF-8',
        method: 'put',
    })
}

//审批转办
export function updateMatter(data) {
    return request({
        url: '/bpm/task/update-assignee',
        data,
        head: 'application/json;charset=UTF-8',
        method: 'put',
    })
}
//根据id查办理表详情
export function queryRunById(id) {
    return request({
        url: '/api/wtbuService/queryRunById?id='+id,
        head: 'application/json;charset=UTF-8',
        method: 'get',
    })
}